/*=========================================================================================
  File Name: moduleKainsActions.js
  Description: Kains Module Actions
  ----------------------------------------------------------------------------------------
==============================*/
import SettingsService from "../../../services/settings.service"

export default {
  async addSettings({ dispatch }, params) {
    return SettingsService.createSettings(params)
      .then(response => {
        dispatch('alertSuccess', typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
      })
      .catch(error => {
        if (Object.values(error.errors).length > 0) {
          dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
        }
        else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
      })
  },
  async updateSettings({ commit, dispatch }, data) {
    return SettingsService.updateSettings(data)
      .then(response => {
        // commit('UPDATE_USER', data)
        dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
      })
      .catch(error => {
        if (typeof error.errors == 'object') {
          if (Object.values(error.errors).length > 0) {
            dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
          }
        }
        else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
      })
  },
  async fetchSettings({ commit, dispatch }, payload) {
    return SettingsService.getSettings(payload)
      .then(response => {
        commit('SET_SETTINGS', response.data.data)
        commit('SET_INFO_DB', { totalPage: response.data.last_page, totalRow: response.data.total })
        return Promise.resolve(response.data.data)
      })
      .catch(error => {
        if (Object.values(error.errors).length > 0) {
          dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
        }
        else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
      })
  },
  async showSettings({ dispatch }, id) {
    return SettingsService.showSettings(id)
      .then(response => {
        return Promise.resolve(response.data)
      })
      .catch(error => {
        if (typeof error.errors == 'object') {
          if (Object.values(error.errors).length > 0) {
            dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
          }
        }
        else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
      })
  },
  async removeSettings({ commit, dispatch }, ids) {
    return SettingsService.deleteSettings({ cids: ids })
      .then(response => {
        dispatch("alertSuccess", typeof response.message == 'object' ? response.message[0] : response.message, { root: true })
      })
      .catch(error => {
        if (typeof error.errors == 'object') {
          if (Object.values(error.errors).length > 0) {
            dispatch("alertError", Object.values(error.errors)[0][0], { root: true });
          }
        }
        else dispatch("alertError", typeof error.message == 'object' ? error.message[0] : error.message, { root: true });
      })
  },
  async getListSettings({ dispatch, commit }, data) {
    return await SettingsService.getListSettings()
      .then(response => {
        if (response.success && response.data) {
          // dispatch("alertSuccess", response.message, { root: true });
          return Promise.resolve(response.data);
        } else {
          dispatch("alertError", response.message, { root: true });
        }
      }).catch(error => {
        dispatch("alertError", error, { root: true });
        return Promise.reject(false);
      })
  },
  async fetchUploadMaxFileSize({ commit, dispatch }, payload) {
    return SettingsService.getUploadMaxFileSize(payload)
      .then(response => {
        return Promise.resolve(response.data)
      })
      .catch(error => {
        dispatch("alertError", error.message, { root: true });
        return Promise.reject(error);
      })
  },
}